import { ProductType } from '../ui-models/datalayer';

export function getProductType(
	isGridCarousel: boolean,
	adId: string | undefined,
	onlineSampleRealProductMapId?: number
): ProductType {
	if (isGridCarousel) {
		return ProductType.ProductInGrid;
	}
	if (!!adId) {
		return ProductType.CPP;
	}
	if (onlineSampleRealProductMapId) {
		return ProductType.CartologyRemarketing;
	}
	return ProductType.Organic;
}
